var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHasBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.962,
    height: 9.962,
    viewBox: "0 0 9.962 9.962",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "feed_FILL0_wght400_GRAD0_opsz48",
    d: "M6.83,15.962a.851.851,0,0,1-.83-.83V6.83A.851.851,0,0,1,6.83,6h6.392l2.74,2.74v6.392a.851.851,0,0,1-.83.83Zm0-.83h8.3V9.2H12.766V6.83H6.83ZM8.2,13.6h5.562v-.83H8.2Zm0-4.4h2.781v-.83H8.2Zm0,2.2h5.562v-.83H8.2ZM6.83,6.83v0Z",
    transform: "translate(-6 -6)",
    fill: "#58585d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHasBackground);
export default __webpack_public_path__ + "static/media/icon-has-background.72164f5abd78e68c15d352160ab03dae.svg";
export { ForwardRef as ReactComponent };